<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.back()">工作室</em>
          <label><i class="el-icon-arrow-right"></i> 创建工作室</label>
        </div>
      </div>
      <div class="content-inner-wrap">
        <el-form
          label-width="120px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="工作室名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="工作室LOGO" prop="fileList">
            <my-el-upload
              :action="upload_url"
              class="upload-demo"
              :file-list="ruleForm.fileList"
              :on-remove="onRemove"
              :on-change="onChangeLogo"
              :before-upload="onBeforeUpload"
              name="image"
              accept="image/png,image/jpeg,image/bmp"
              list-type="picture"
            >
              <el-button size="small" class="uploadBtn">
                <i class="icon icon-upload"></i><span>上传文件</span></el-button
              >
              <div slot="tip" class="el-upload__tip">
                <p>请上传工作室的LOGO图片，建议尺寸为：200*200</p>
                <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
              </div>
            </my-el-upload>
          </el-form-item>
          <el-form-item label="工作室简介" prop="description">
            <el-input
              type="textarea"
              v-model="ruleForm.description"
              :rows="4"
            ></el-input>
            <template slot="error">
              <div class="el-form-item__error">
                简介信息请控制在 10 至 150 字之间
              </div>
            </template>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact">
            <el-input v-model="ruleForm.contact"></el-input>
          </el-form-item>
          <el-form-item class="footerItem">
            <el-button type="primary" @click="submitForm()" v-if="submitBle">
              提交申请</el-button
            >
            <el-button type="info" disabled v-else> 提交申请</el-button>
            <el-button type="info" @click="$router.back()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import MyUpload from '../../../components/MyUpload.vue';
import {
  UPLOAD_URL,
  checkLenStudioName,
  isEmail,
  isValidFileSize,
  isIntNum,
} from '../CONST';
import { studioRegister } from '@/api/studio';
export default {
  components: {
    [MyUpload.name]: MyUpload,
  },
  data() {
    const checkContact = (rule, value, callback) => {
      if (isEmail(value) || isIntNum(value)) {
        callback();
      } else {
        callback(new Error('请填写正确的联系方式'));
      }
    };
    return {
      ruleForm: {
        contact: '',
        name: '',
        description: '',
        head: '',
        fileList: [],
      },
      submitBle: true,
      upload_url: UPLOAD_URL,
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请填写工作室名称', trigger: 'blur' },
          { min: 6, max: 24, trigger: 'blur', validator: checkLenStudioName },
        ],
        description: [
          {
            required: true,
            message: '请输入工作室描述，最多150字',
            trigger: 'change',
          },
          { min: 10, max: 150, trigger: 'change' },
        ],
        contact: [
          {
            required: true,
            message: '请填写联系方式',
            trigger: 'blur',
            validator: checkContact,
          },
        ],
        fileList: [
          {
            type: 'array',
            required: true,
            message: '请上传工作室logo',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    onBeforeUpload(file) {
      return isValidFileSize(file.size, () =>
        this.$message.error('请限制文件大小在10M以内'),
      );
    },
    onChangeLogo(file) {
      if (file.status === 'success' && file.response.code === 200) {
        let { image } = file.response.data;
        this.ruleForm.fileList = [{ name: file.name, url: image.cdn_url }];
      }
    },
    onRemove(file) {
      let delIndex = -1;
      this.ruleForm.fileList.forEach((val, index) => {
        if (val.url === file.url) delIndex = index;
      });
      if (delIndex >= 0) {
        this.ruleForm.fileList.splice(delIndex, 1);
      }
    },
    submitForm() {
      console.log('submitForm');
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.submitBle = false;
          let params = Object.assign(
            { json: 1 },
            {
              name: this.ruleForm.name,
              description: this.ruleForm.description,
              head: this.ruleForm.fileList[0].url,
              contact: this.ruleForm.contact,
            },
          );
          studioRegister(params)
            .then(res => {
              if (res.code == 0) {
                this.$message.success('提交申请成功，请等待审核后生效');
                setTimeout(() => {
                  this.$router.push({ name: 'creatorHome' });
                }, 2000);
              }
            })
            .catch(e => {
              console.log(e);
              this.submitBle = true;
            });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      console.log('delete', arguments, this.fileList);
    },
    handlePreview() {
      console.log('preview');
    },
    uploadSuccess(response, file, fileList) {
      console.log('uploadSuccess', response, file, fileList);
      if (response.code === 200) {
        let { image } = response.data;
        let { name, size } = file;
        console.log(name, size, image);
      }
    },
  },
};
</script>
<style
  src="../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .block {
    .title-wrap {
      .title-name {
        em {
          cursor: pointer;
        }
        label {
          color: #8c8c8c;
        }
      }
    }
    .content-inner-wrap {
      ::v-deep .el-form {
        width: 480px;
        margin-top: 49px;
        margin-left: 212px;
        .el-form-item__label {
          font-size: 16px;
        }
        .el-form-item {
          margin-bottom: 40px;
        }
        .footerItem {
          margin-left: 48px;
          margin-top: 66px;
          .el-form-item__content {
            margin-left: 0 !important;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .el-button {
              width: 201px;
              height: 50px;
              font-size: 20px;
              border-radius: 8px;
              + .el-button {
                margin-left: 39px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
